import { z } from 'zod';

const operationSchema = z.enum(['and', 'or']);

const relativeDateValueSchema = z.object({
  type: z.literal('relative'),
  key: z.string().optional(),
  unit: z.enum(['day', 'week', 'month', 'year']),
  amount: z.number().int(),
});

const absoluteDateValueSchema = z.object({
  type: z.literal('absolute'),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
});

const tokenValueSchema = z.union([
  z.string(),
  relativeDateValueSchema,
  absoluteDateValueSchema,
  z.null(),
]);

const tokenSchema = z.object({
  propertyKey: z.string().optional(),
  operator: z.string(),
  value: tokenValueSchema,
});

export type Token = z.infer<typeof tokenSchema>;

const tokenGroupSchema = z.object({
  operation: operationSchema,
  tokens: tokenSchema.array(),
});

export type TokenGroup = z.infer<typeof tokenGroupSchema>;

const itemFilterQuerySchema = z.object({
  operation: operationSchema,
  tokens: tokenSchema.array(),
  tokenGroups: tokenSchema.or(tokenGroupSchema).array().optional(),
});

export type ItemFilterQuery = z.infer<typeof itemFilterQuerySchema>;

export const filterModalSchema = z.object({
  id: z.string(),
  title: z.string().min(1, { message: 'Required' }),
  itemFilterQuery: itemFilterQuerySchema,
});

export type FilterModal = z.infer<typeof filterModalSchema>;

export const customRibbonFiltersSchema = filterModalSchema.array();

export type CustomRibbonFilters = z.infer<typeof customRibbonFiltersSchema>;
